<template>
    <div>
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title title-typography-color">
            <i aria-hidden="true" class="fas fa-clone"></i>
            Plantilla Contactos
          </h4>
        </template>
        <template v-slot:headerAction>
          <b-button class="float-right mr-3" right variant="success" @click="updateOrganizationTemplate" >{{
            $t("public.components.organization.preferences.btnModify")
          }}
          </b-button>
        </template>
        <template v-slot:body>
          <PreferencesTemplatesPatient ref="form" :organization="organization" />
        </template>
      </iq-card>
    </div>
  </template>
  <script>
  import { xray } from "../../config/pluginInit";
  
  import organizationService from "../../services/organization";
  
  import PreferencesTemplatesPatient from "../../components/organization/PreferencesTemplatesPatient";
  
  export default {
    name: "OrganizationTemplates",
    props: {
      organization: undefined
    },
    mounted() {
      xray.index();
    },
    methods: {
      async updateOrganizationTemplate(){
        this.$refs.form.save();
      }
    },
    computed: {},
    data() {
      return {
        organizationTemplate: undefined,
      };
    },
    components: { PreferencesTemplatesPatient },
  };
  </script>